import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'
import Box from 'features/Hotel/Box'
import { useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import hotelApi from 'services/api/hotel'

import styles from './AutoReply.module.scss'

const AutoReply = ({ autoReplySettings }) => {
  const [isEnabled, setIsEnabled] = useState(autoReplySettings.isEnabled)
  const [startTime, setStartTime] = useState(autoReplySettings.startTime || '22:00:00')
  const [endTime, setEndTime] = useState(autoReplySettings.endTime || '09:00:00')

  const { addToast } = useToasts()

  const [isManuallyChanged, setisManuallyChanged] = useState(false)

  function handleChangeIsEnabled(value) {
    setisManuallyChanged(true)
    setIsEnabled(value)
  }

  function handleChangeStartTime(value) {
    setisManuallyChanged(true)
    setStartTime(value)
  }

  function handleChangeEndTime(value) {
    setisManuallyChanged(true)
    setEndTime(value)
  }

  useEffect(() => {
    if (isManuallyChanged) {
      hotelApi
        .updateAsUser({ autoReplySettings: { isEnabled, startTime, endTime } })
        .catch(() => {
          addToast('Something went wrong while updating auto-reply settings', {
            appearence: 'error'
          })
        })
    }
  }, [isManuallyChanged, isEnabled, startTime, endTime, addToast])

  return (
    <Box title="Auto reply">
      <label className={styles.toggleHolder}>
        <Toggle
          checked={isEnabled}
          handleChange={e => handleChangeIsEnabled(e.target.checked)}
        />
        <span className={styles.toggleLabel}>Use auto-reply</span>
      </label>
      <div
        className={isEnabled ? styles.timeInputsHolder : styles.timeInputsHolderDisabled}
      >
        <p className={styles.toggleLabel}>Send auto-reply between</p>
        <TextInput
          label="Start time"
          className={styles.input}
          value={startTime}
          onChange={e => handleChangeStartTime(e.target.value)}
          type="time"
        />
        <TextInput
          label="End time"
          className={styles.input}
          value={endTime}
          onChange={e => handleChangeEndTime(e.target.value)}
          type="time"
        />
      </div>
    </Box>
  )
}

export default AutoReply
